import { Button } from "@progress/kendo-react-buttons";
import style from './PaginatedList.module.scss'
import { classNames } from '@progress/kendo-react-common';
import { useEffect, useState } from "react";
import { InputSuffix, TextBox, TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "components/Icon/Icon";


interface PaginationButtonProps {
  getPaginationNumbers: (string | number)[],
  setCurrentPage: (value: number) => any,
  currentPage: number
}

export default function PaginationButton ({ getPaginationNumbers, setCurrentPage, currentPage }: PaginationButtonProps) {
    return(
        <>
            {getPaginationNumbers.map((page,index) => {
            const pageIsNumber = typeof page === "number";
            return (
                <Button
                    rounded={'medium'}
                    themeColor={'tertiary'}
                    key={index.toString()}
                    onClick={() => pageIsNumber && setCurrentPage(page)}
                    disabled={!pageIsNumber || (pageIsNumber && currentPage === page)}
                    className={classNames(style.pageButton, { [style.currentPage]: (pageIsNumber && currentPage === page)})}
                >
                    {page}
                </Button>
            )})}
        </>
    )
}

interface ChangePageInputProps{
    currentPageValue: number,
    maximumPage: number
    setCurrentPage: (value: number) => void
  }
  
export function ChangePageInput({currentPageValue, maximumPage, setCurrentPage} :ChangePageInputProps){
    const [page, setPage] = useState(currentPageValue);
    useEffect(()=>setPage(currentPageValue),[currentPageValue]);

    const handlePageChange = (e: TextBoxChangeEvent) => {
        const value = Number(e.target.value);
        if (isNaN(value)) return;

        setPage(value);
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            if(page <= 0) setPage(1);
            if(page > maximumPage) setPage(maximumPage); 

            setCurrentPage(page);
        }
    };

    return (    
  
            <TextBox
                valid={!(page <= 0 || page > maximumPage)}
                className={style.input}
                value={page}
                onKeyDown={handleKeyDown}
                onChange={handlePageChange}
            /> 
    )
}